/**
 * Created by Claude on 21.08.2026
 */

class ScriptComponent extends BaseComponent {
    onBeforeCreate() {
        super.onBeforeCreate();

        if (this.context.editing) {
            this.wrapMethods();
        }
    }

    wrapMethods() {
        const names = new Set();

        let proto = Object.getPrototypeOf(this);
        while (proto && proto !== Object.prototype) {
            Object.getOwnPropertyNames(proto).forEach((name) => {
                const descriptor = Object.getOwnPropertyDescriptor(proto, name);
                if (name !== "constructor" && typeof descriptor.value === "function") {
                    names.add(name);
                }
            });
            proto = Object.getPrototypeOf(proto);
        }

        names.forEach((name) => {
            const original = this[name];
            this[name] = function (...args) {
                try {
                    return original.apply(this, args);
                } catch (error) {
                    console.error(error);
                }
            };
        });
    }
}
